var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSjfx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17.781 17.781",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.781006,
    height: 17.781006,
    fill: "none",
    customFrame: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4 4127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8054\\u5408 24",
    d: "M10.9318 6.58667C10.802 6.50642 10.6545 6.46594 10.507 6.46594C10.3832 6.46594 10.2595 6.49422 10.1453 6.55128L6.91272 8.16772C6.63879 8.3046 6.46582 8.5845 6.46582 8.89062L6.46582 14.5482C6.46582 14.9946 6.82776 15.3564 7.27417 15.3564L10.507 15.3564C10.9534 15.3564 11.3151 14.9946 11.3151 14.5482L11.3151 7.27419C11.3151 6.99406 11.1702 6.73392 10.9318 6.58667Z",
    fill: "rgb(166,179,202)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8054\\u5408 24",
    d: "M10.9318 6.58667C10.802 6.50642 10.6545 6.46594 10.507 6.46594C10.3832 6.46594 10.2595 6.49422 10.1453 6.55128L6.91272 8.16772C6.63879 8.3046 6.46582 8.5845 6.46582 8.89062L6.46582 14.5482C6.46582 14.9946 6.82776 15.3564 7.27417 15.3564L10.507 15.3564C10.9534 15.3564 11.3151 14.9946 11.3151 14.5482L11.3151 7.27419C11.3151 6.99406 11.1702 6.73392 10.9318 6.58667Z",
    fillRule: "evenodd",
    stroke: "rgb(51,51,51)",
    strokeOpacity: 0,
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4 4129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 9921",
    d: "M16.9724 17.781L0.808211 17.781C0.361848 17.781 0 17.4191 0 16.9728C0 16.5264 0.361848 16.1646 0.808211 16.1646L16.9724 16.1646C17.4188 16.1646 17.7806 16.5264 17.7806 16.9728C17.7806 17.4191 17.4188 17.781 16.9724 17.781Z",
    fill: "rgb(120,138,173)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 9921",
    d: "M0.808211 17.781C0.361848 17.781 0 17.4191 0 16.9728C0 16.5264 0.361848 16.1646 0.808211 16.1646L16.9724 16.1646C17.4188 16.1646 17.7806 16.5264 17.7806 16.9728C17.7806 17.4191 17.4188 17.781 16.9724 17.781L0.808211 17.781Z",
    fillRule: "nonzero",
    stroke: "rgb(51,51,51)",
    strokeOpacity: 0,
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8054\\u5408 26",
    d: "M1.00439 8.91464C0.939331 8.89842 0.873657 8.8905 0.808228 8.8905C0.630005 8.8905 0.454224 8.9496 0.310791 9.06166C0.114624 9.21484 0 9.44983 0 9.69872L0 14.548C0 14.9944 0.361816 15.3563 0.808228 15.3563L4.04102 15.3563C4.48743 15.3563 4.84937 14.9944 4.84937 14.548L4.84937 10.5069C4.84937 10.1361 4.59705 9.81279 4.23694 9.72285L1.00439 8.91464Z",
    fill: "rgb(120,138,173)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8054\\u5408 26",
    d: "M1.00439 8.91464C0.939331 8.89842 0.873657 8.8905 0.808228 8.8905C0.630005 8.8905 0.454224 8.9496 0.310791 9.06166C0.114624 9.21484 0 9.44983 0 9.69872L0 14.548C0 14.9944 0.361816 15.3563 0.808228 15.3563L4.04102 15.3563C4.48743 15.3563 4.84937 14.9944 4.84937 14.548L4.84937 10.5069C4.84937 10.1361 4.59705 9.81279 4.23694 9.72285L1.00439 8.91464Z",
    fillRule: "evenodd",
    stroke: "rgb(51,51,51)",
    strokeOpacity: 0,
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8054\\u5408 25",
    d: "M17.3975 3.35376C17.2677 3.27351 17.1206 3.23303 16.9727 3.23303C16.8492 3.23303 16.7253 3.26131 16.6113 3.31836L13.3784 4.93481C13.1045 5.07172 12.9316 5.35158 12.9316 5.6577L12.9316 14.5482C12.9316 14.9945 13.2935 15.3564 13.7399 15.3564L16.9727 15.3564C17.4191 15.3564 17.7809 14.9945 17.7809 14.5482L17.7809 4.04126C17.7809 3.76114 17.6359 3.50101 17.3975 3.35376Z",
    fill: "rgb(120,138,173)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8054\\u5408 25",
    d: "M17.3975 3.35376C17.2677 3.27351 17.1206 3.23303 16.9727 3.23303C16.8492 3.23303 16.7253 3.26131 16.6113 3.31836L13.3784 4.93481C13.1045 5.07172 12.9316 5.35158 12.9316 5.6577L12.9316 14.5482C12.9316 14.9945 13.2935 15.3564 13.7399 15.3564L16.9727 15.3564C17.4191 15.3564 17.7809 14.9945 17.7809 14.5482L17.7809 4.04126C17.7809 3.76114 17.6359 3.50101 17.3975 3.35376Z",
    fillRule: "evenodd",
    stroke: "rgb(51,51,51)",
    strokeOpacity: 0,
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 9925",
    d: "M4.04123 8.08224C3.97561 8.08224 3.90979 8.07425 3.84523 8.05811L0.612384 7.24989C0.179348 7.14163 -0.0839343 6.70281 0.0243211 6.26977C0.132581 5.83673 0.571386 5.57344 1.00442 5.6817L3.94722 6.41741L13.549 1.61645L12.9316 1.61645C12.4852 1.61645 12.1234 1.25459 12.1234 0.808224C12.1234 0.361854 12.4852 0 12.9316 0L16.9726 0C17.3475 0 17.6731 0.257722 17.7592 0.622531C17.8453 0.987343 17.6693 1.36349 17.3341 1.53112L4.40269 7.99691C4.28966 8.05343 4.16581 8.08224 4.04123 8.08224Z",
    fill: "rgb(120,138,173)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 9925",
    d: "M3.84523 8.05811L0.612384 7.24989C0.179348 7.14163 -0.0839343 6.70281 0.0243211 6.26977C0.132581 5.83673 0.571386 5.57344 1.00442 5.6817L3.94722 6.41741L13.549 1.61645L12.9316 1.61645C12.4852 1.61645 12.1234 1.25459 12.1234 0.808224C12.1234 0.361854 12.4852 0 12.9316 0L16.9726 0C17.3475 0 17.6731 0.257722 17.7592 0.622531C17.8453 0.987343 17.6693 1.36349 17.3341 1.53112L4.40269 7.99691C4.28966 8.05343 4.16581 8.08224 4.04123 8.08224C3.97561 8.08224 3.90979 8.07425 3.84523 8.05811Z",
    fillRule: "nonzero",
    stroke: "rgb(51,51,51)",
    strokeOpacity: 0,
    strokeLinecap: "round",
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSjfx);
export default __webpack_public_path__ + "static/media/sjfx.ab7398405c020940795ec7f4251476fd.svg";
export { ForwardRef as ReactComponent };